"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/Switch/index.ts
var Switch_exports = {};
__export(Switch_exports, {
  Switch: () => Switch,
  SwitchTheme: () => SwitchTheme
});
module.exports = __toCommonJS(Switch_exports);

// src/components/Switch/Switch.tsx
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
var SwitchTheme = /* @__PURE__ */ ((SwitchTheme2) => {
  SwitchTheme2["Yellow"] = "yellow";
  SwitchTheme2["Blue"] = "blue";
  SwitchTheme2["Magenta"] = "magenta";
  return SwitchTheme2;
})(SwitchTheme || {});
function Switch({
  value: defaultValue = false,
  disabled = false,
  onToggle,
  bodyClassName,
  buttonClassName,
  theme = "yellow" /* Yellow */
}) {
  const [value, setValue] = (0, import_react.useState)(defaultValue);
  const onToggleHandler = (value2) => {
    if (disabled)
      return;
    setValue(value2);
    onToggle == null ? void 0 : onToggle(value2);
  };
  return /* @__PURE__ */ import_react.default.createElement(
    "span",
    {
      className: (0, import_classnames.default)(
        bodyClassName,
        "v2-block v2-w-16 v2-h-8 v2-rounded-full v2-p-0.5",
        {
          "v2-bg-neutral-300": !value && !disabled,
          "v2-bg-neutral-200 v2-cursor-not-allowed": disabled,
          "v2-transition-all v2-duration-150 hover:v2-bg-yellow-200 v2-cursor-pointer": !disabled,
          "v2-bg-yellow-500": value && !disabled && theme === "yellow" /* Yellow */,
          "v2-bg-blue-500": value && !disabled && theme === "blue" /* Blue */,
          "v2-bg-magenta-500": value && !disabled && theme === "magenta" /* Magenta */,
          "hover:v2-bg-yellow-200": !disabled && theme === "yellow" /* Yellow */,
          "hover:v2-bg-blue-200": !disabled && theme === "blue" /* Blue */,
          "hover:v2-bg-magenta-200": !disabled && theme === "magenta" /* Magenta */
        }
      ),
      onClick: () => onToggleHandler(!value)
    },
    /* @__PURE__ */ import_react.default.createElement(
      "i",
      {
        className: (0, import_classnames.default)(
          buttonClassName,
          [
            "v2-block v2-relative v2-rounded-full v2-ease-out",
            " v2-h-full v2-w-1/2 v2-transition-all v2-duration-500"
          ],
          {
            "v2-ml-[0%]": !value,
            "v2-ml-[50%]": value,
            "v2-bg-white": !disabled,
            "v2-bg-neutral-100": disabled
          }
        )
      }
    )
  );
}
